/**
 * All GA events and Pageload with default options
 */

export const GA_ACCOUNT_ID = 'UA-5568615-7';
export const GA_TRACKER_NAME = 'quikrJobsPWAtracker';

export const PAGE_LOAD = {
  applyinitiate: {
    page: '/applyinitiate',
    options: { type: 'vapapply' }
  },

  inlineapplyonadfrombrowse: {
    page: '/inlineapplyonadfrombrowse',
    options: { }
  },

  applyError: {
    page: '/Errorinapply',
    options: { step: 1 }
  },

  viewContact: {
    page: '/call',
    options: { step: 1 }
  },

  undoApply: {
    page: '/undo_apply',
    options: { step: 1 }
  },

  expressApplySuccess: {
    page: '/ExpressApply_Success',
    options: { }
  },

  expressApplyFailure: {
    page: '/expressapply_failure',
    options: { }
  },

  applySuccess: {
    page: '/apply',
    options: { step: 1 }
  },

  vapPageLoad: {
    page: 'view-ad',
    options: {}
  },

  snbPageLoad: {
    page: 'SnB',
    options: { type: 'browse' }
  },

  cityChangedInStepOne: {
    page: '/CandidateCurrentCityChangeFromStepOne',
    options: {}
  },

  cityChangedGAInUpdateApplication: {
    page: '/CandidateCurrentCityChange',
    options: {}
  },

  guaranteedJobPageView: {
    page: 'guaranteedJobPageView',
    options: {}
  },

  search: {
    page: 'search',
    options: { keyw: '' }
  },

  browse: {
    page: 'browse',
    options: {}
  },

  guaranteedJobAction: {
    page: 'guaranteedJobAction',
    options: {}
  },

  kotakThirdpartyAction: {
    page: 'KotakClick',
    options: {}
  },

  homePage: {
    page: 'Hp',
    options: { type: 'Tile',catname: 'Jobs',PageType: 'Candidate' }
  },

  papFreeAdLimit: {
    page: 'jobs_pap_step_one_response_ERROR_USER_DAILY_AD_LIMIT_EXCEEDED_ERROR',
    options: {}
  },

  papStep2Initiate: {
    page: 'PAP_step2_initiate',
    options: {}
  },

  papInitiate: {
    page: 'pap_initiate',
    options: {}
  },

  helloEnglish: {
    page: 'vap',
    options: { display_type: 'hello_english_recommended_score',PageType: 'Candidate' }
  },

  ampApplyError: {
    page: '/ampApplyError',
    options: {}
  },

  integration: {
    page: '/integrationFormSubmit',
    options: {}
  },

  applyFilter: {
    page: '/applyFilter',
    options: {}
  },

  campaignManager: {
    page: '/campaignManager',
    options: {}
  },

  applyWithoutEmail: {
    page: '/applyWithoutEmail',
    options: {}
  },

  pwaPAPWhatsappChatLinkClicked: {
    page: '/pwaPAPWhatsappChatLinkClicked',
    options: {}
  },

  profileRichnessForm: {
    page: '/profileRichness',
    options: {}
  },

  fullScreenBanner: {
    page: '/fullScreenBanner',
    options: {}
  },

  candidateTest: {
    page: '/candidateTest',
    options: {}
  },

  feedback: {
    page: '/feedback',
    options: {}
  },
  newPapInitiate: {
    page: 'new_pap_initiate',
    options: {}
  },
  papStep1Success :{
    page: 'new_pap_success',
    options: {}
  }
};

//All default options for page load GA's in Jobs Category
export const DEFAULT_PAGELOAD_OPTIONS = {
  catname: 'Jobs',
  t73: 'JobsResponsiveUI',
  v73: 'True',
  Language: 'en',
  Pagetype: 'Candidate',
  pwaRequest: 1
};

export const SNB_SCROLL_DOCUMENT_COUNT = 4;



// WEBPACK FOOTER //
// ../q-jobs/src/constants/ga.js